// src/App.js
import React, { useState, useEffect } from "react";
import { HashRouter as Router } from "react-router-dom";
import { SchoolProvider } from "../../config/SchoolContext";
import { AuthProvider } from "../../config/AuthContext";
import ResponsiveAppBar from "../Layout/ResponsiveAppBar";
import MainRoutes from "../Routes/MainRoutes";
import { LicenseInfo } from "@mui/x-license-pro";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { requestForToken, onMessageListener } from "../../config/firebase"; // Import the functions

LicenseInfo.setLicenseKey(
  "6f1f32f7d66154d8c959ccbdfe50e841Tz0xMjM0MDgsRT0xNzk3NzI0Nzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y"
);

const App = () => {
  const [darkMode, setDarkMode] = useState(() => {
    const savedPreference = localStorage.getItem("darkMode");
    return savedPreference ? JSON.parse(savedPreference) : false;
  });

  useEffect(() => {
    localStorage.setItem("darkMode", JSON.stringify(darkMode));
  }, [darkMode]);

  useEffect(() => {
    requestForToken();

    onMessageListener()
      .then((payload) => {
        console.log("New message received. ", payload);
        // Display the notification to the user
        // You can use a library like react-toastify or a custom component
        alert(payload.notification.body);
      })
      .catch((err) => console.log("failed: ", err));
  }, []);

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
      background: {
        default: darkMode ? "#121212" : "#ffffff",
        paper: darkMode ? "#1d1d1d" : "#ffffff",
      },
      text: {
        primary: darkMode ? "#ffffff" : "#000000",
      },
      primary: {
        main: "#1976d2",
      },
      secondary: {
        main: "#dc004e",
      },
      error: {
        main: "#f44336",
      },
      success: {
        main: "#4caf50",
      },
    },
    components: {
      MuiBreadcrumbs: {
        styleOverrides: {
          root: {
            backgroundColor: darkMode ? "#AC1A2F" : "#AC1A2F",
            color: darkMode ? "#ffffff" : "#ffffff",
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SchoolProvider>
        <AuthProvider>
          <Router>
            <ResponsiveAppBar darkMode={darkMode} setDarkMode={setDarkMode} />
            <MainRoutes />
          </Router>
        </AuthProvider>
      </SchoolProvider>
    </ThemeProvider>
  );
};

export default App;
